import React, { Component } from 'react'

export default class ActionWithPlus extends Component {
    render() {
        return (
            <a href="/" onClick={event => {
                event.preventDefault();
                this.props.onClick();
            }}>
                <i className="mdi mdi-plus-box-outline"></i> {this.props.label}
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ActionWithPlus.js